import { render } from "./Example.vue?vue&type=template&id=482a1b06&scoped=true"
import script from "./Example.vue?vue&type=script&lang=js"
export * from "./Example.vue?vue&type=script&lang=js"

import "./Example.vue?vue&type=style&index=0&id=482a1b06&lang=scss&scoped=true"
script.render = render
script.__scopeId = "data-v-482a1b06"

export default script